import ExpertBackground from 'components/atoms/ExpertBackground';
import type { FC, PropsWithChildren, ReactNode } from 'react';

const AuthPageLayout: FC<
  PropsWithChildren<{
    title: string | ReactNode;
    subTitle: string | ReactNode;
    renderAside?: () => JSX.Element;
    renderFooter?: () => JSX.Element;
    renderNavigationBar?: () => JSX.Element;
  }>
> = ({
  title,
  subTitle,
  children,
  renderAside,
  renderFooter,
  renderNavigationBar,
}) => {
  return (
    <ExpertBackground>
      <div className="flex flex-col md:flex-row">
        <div className="flex flex-col flex-[7] min-h-[calc(100vh-1rem)] bg-white rounded-3xl shadow-cardBlur backdrop-blur-md p-6 z-20 m-2 justify-between">
          {renderNavigationBar?.()}
          <main className="flex-1 flex flex-col items-center pt-[2.5rem] relative">
            <div className="text-center flex flex-col items-center">
              {title}
              <div className="text-primary-600 text-lg text-center">
                {typeof subTitle === 'string' ? <p>{subTitle}</p> : subTitle}
              </div>

              <div className="mt-8 mx-auto w-full">{children}</div>
            </div>
          </main>
          <div>{renderFooter?.()}</div>
        </div>
        <aside className="relative overflow-hidden flex-[3] min-w-[20rem] flex-col items-center m-2">
          {renderAside?.()}
        </aside>
      </div>
    </ExpertBackground>
  );
};

export default AuthPageLayout;
